module.exports = __webpack_public_path__ + "roboto-v20-latin-regular.woff2?479970ffb74f2117317f9d24d9e317fe";